export default "__VITE_ASSET__BRqGEi2K__"